import { render, staticRenderFns } from "./creatdoc.vue?vue&type=template&id=720bce24&scoped=true&"
import script from "./creatdoc.vue?vue&type=script&lang=js&"
export * from "./creatdoc.vue?vue&type=script&lang=js&"
import style0 from "./creatdoc.vue?vue&type=style&index=0&id=720bce24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720bce24",
  null
  
)

export default component.exports